import cx from 'classnames'
import Route from 'route-parser'
import { useDispatch, useSelector } from 'react-redux'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import useObservable from 'libraries/front-end-core/hooks/useObservable'
import { URL_DOC_DRAFTER_DOCUMENT_INTERVIEW } from 'constants/urls'
import { $user } from 'services/SessionService'
import { setSignUpModalIsOpen, setUserRolesModalIsOpen } from 'redux/actions'
import selectUserAccessRoles from 'redux/selectors/selectAccessRoles'
import { Document } from 'services/DocumentService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import { FileCog as FileCogIcon } from 'lucide-react'

const DocDrafterRoute = new Route(URL_DOC_DRAFTER_DOCUMENT_INTERVIEW)

interface LinkProps extends SuiteLinkProps {
  isLogged: boolean
  accessRoles: string[]
  selectable: boolean
}

function Link ({
  aol,
  id,
  isLogged,
  accessRoles,
  clarilis,
  cta = '',
  selectable
}: LinkProps): JSX.Element {
  const dispatch = useDispatch()
  const hasClarilisAccess = accessRoles.includes('corporate_documents_clarilis')
  const hasDocDrafterAccess = accessRoles.includes('corporate_documents_docdrafter')
  const href = (() => {
    if (!isLogged) {
      return ''
    }

    if (clarilis && hasClarilisAccess) {
      return cta
    }

    if (!clarilis && hasDocDrafterAccess) {
      const route = DocDrafterRoute.reverse({ aol, id })
      return route
    }

    return ''
  })()

  return (
    <a
      href={href}
      className={cx('w7 h2 bg-transparent pointer relative right6 static-m mr0-m', { mr11: selectable, 'mr10-half': !selectable })}
      onClick={() => {
        if (!isLogged) {
          return dispatch(setSignUpModalIsOpen(true))
        }

        if (!clarilis && !hasDocDrafterAccess) {
          return dispatch(setUserRolesModalIsOpen(true))
        }

        if (clarilis && !hasClarilisAccess) {
          return dispatch(setUserRolesModalIsOpen(true))
        }
      }}
      {...((href.length > 0) && {
        target: '_blank',
        rel: 'noopener noreferrer',
        'data-event-category': 'Documents',
        'data-event-action': 'Interview',
        'data-event-label': `${id}`
      })}
    >
      <FileCogIcon name='icon-file-document' className='h-100 w-100 precedents-blue' />
    </a>
  )
}

interface SuiteLinkProps extends Pick<Document, | 'clarilis' | 'id' | 'cta'> {
  aol: string
  selectable: boolean
}

export default function SuiteLink (props: SuiteLinkProps): JSX.Element {
  const accessRoles = useSelector(selectUserAccessRoles)
  const response = useObservable(
    $user,
    RESPONSE_PENDING
  )

  return (
    <ResponseConsumer
      response={response}
      content={() => <Link {...props} isLogged accessRoles={accessRoles} />}
      unauthorizedComponent={() => <Link {...props} isLogged={false} accessRoles={[]} />}
    />
  )
}
